import mapSliceToComponent from '~/imports/category_page'
import { PRISMIC_TYPES } from '~/lib/prismic-types'

import PageWithFilters from '~/components/PageWithFilters'
import HeroCategorySimpleTitle from '~/components/Slices/HeroCategorySimpleTitle'
import HeroMain from '~/components/Slices/HeroMain'
import CategoryBottomPage from '~/components/UI/CategoryBottomPage'
import SliceManager from '~/components/UI/SliceManager'

import getCategoryPageStaticPropsFunction from '~/data/category-page-data'
import { CategoryPageData } from '~/data/category-page-data/serializer'

import css from './styles.module.scss'

export default function CategoryFragrance({
  categoryHero,
  defaultFilters,
  facets,
  isHeroTitleOnly,
  slices,
  ...rest
}: CategoryPageData) {
  return (
    <>
      {isHeroTitleOnly ? (
        <HeroCategorySimpleTitle {...categoryHero?.heroSimple} />
      ) : (
        <HeroMain
          className={css.heroMain}
          isFirstSlice={true}
          {...categoryHero?.heroMain}
          isWithoutText
        />
      )}
      <PageWithFilters
        defaultFilters={defaultFilters}
        facets={facets}
        {...rest}
      />
      <SliceManager
        mapSliceTypeToComponent={mapSliceToComponent}
        slicesData={slices}
        customStartPosition={2}
      />

      <CategoryBottomPage
        isHeroTitleOnly={isHeroTitleOnly}
        categoryHero={categoryHero}
      />
    </>
  )
}

export const getStaticProps = getCategoryPageStaticPropsFunction(
  PRISMIC_TYPES.ROOT_CATEGORY_FRAGRANCE_V2,
)
